import { ButtonIconSquare } from '@/modules/base/components/buttons'
import { isMeinBuero } from '@/utils/build-env'
import { makeStyles } from '@mui/styles'
import { TabInput } from '@/modules/base/components/inputs/index'
import { Title } from '@/modules/base/components/texts'
import { useSelector } from 'react-redux'
import ArrowBackIcon from '@assets/images/icons/arrow_back.svg'
import CheckIcon from '@assets/images/icons/icon_feather_check.svg'
import lang from '@/lang'
import config from '@/config'
import ProductDocumentBlueIcon from '@assets/images/icons/product_document_tab_content.svg'
import ProductDocumentIcon from '@assets/images/icons/product_document_tab.svg'
import ProductMainBlueIcon from '@assets/images/icons/product_main_tab_content.svg'
import ProductMainIcon from '@assets/images/icons/product_main_tab.svg'
import ProductStaffBlueIcon from '@assets/images/icons/product_staff_tab_content.svg'
import ProductStaffIcon from '@assets/images/icons/product_staff_tab.svg'
import PropTypes from 'prop-types'
import React, { Fragment, useEffect, useState } from 'react'
import SelectionCard from '@/modules/base/components/selection-card/selection-card'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { isTabletScreen } from '@/modules/_helpers/detectMobile'
import clsx from 'clsx'
import theme from '@/theme'
import { useElevateHubSpotChat } from '@/modules/hubspot/_helpers/useElevateHubSpotChat'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

const TAB_INDICES = { main: 0, document: 1, staff: 2 }
const isMeinbuero = isMeinBuero()
const subscriptionTypeIcon = {
  document: ProductDocumentIcon,
  main: ProductMainIcon,
  staff: ProductStaffIcon,
}
const subscriptionTypeContentIcon = {
  document: ProductDocumentBlueIcon,
  main: ProductMainBlueIcon,
  staff: ProductStaffBlueIcon,
}
const iconProps = {
  width: '14px',
  height: '14px',
  fill: theme.colorPrimaryButtonBackground,
}

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'visible',
    '& >:first-child': {
      overflow: 'visible !important',
    },

    [theme.devices.tablet]: {
      width: '100%',
      maxWidth: '100vw',
      overflow: 'scroll',
      alignItems: 'center',
    },
  },
  indicator: {
    display: 'none',
  },
  tab: {
    border: theme.border,
    fontFamily: 'inherit',
    fontWeight: theme.fontWeights.regular,
    textTransform: 'none',
    fontSize: theme.fontSizes.default,
    opacity: 1,
    marginTop: '15px',
    marginBottom: '15px',
    minHeight: '150px',
    maxWidth: '355px',
    minWidth: '335px',
    borderRadius: '4px',
    padding: 17,
    position: 'relative',
    '& >:first-child': {
      width: 'auto !important',
    },
    '&:hover': {
      border: `solid 1px ${theme.borderOutlineColor}`,
      background: theme.white,
    },

    [theme.devices.tablet]: {
      minHeight: 'fit-content',
      minWidth: 'fit-content',
      alignItems: 'flex-start',

      '&:not(:first-of-type)': {
        borderLeftWidth: 1,
      },
    },
  },
  tabContainer: {
    [theme.devices.tablet]: {
      justifyContent: 'space-between',
      gap: 20,
    },
  },
  selected: {
    borderRadius: theme.borderRadius,
    backgroundColor: theme.backgroundLight,
    border: `solid 1px ${theme.borderOutlineColor}`,
    position: 'relative',
    overflow: 'visible',
    '&:hover': {
      background: theme.backgroundLight,
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      right: '0px',
      width: '15px',
      height: '15px',
      background: theme.backgroundLight,
      borderRight: `1px solid ${theme.borderOutlineColor}`,
      borderBottom: `1px solid ${theme.borderOutlineColor}`,
      transform: 'rotate(-45deg) translate(50%, 3px)',
      transformOrigin: 'center',

      [theme.devices.tablet]: {
        left: '50%',
        bottom: 0,
        transform: 'translate(-50%, 50%) rotate(45deg)',
      },
    },
  },

  tabOverview: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 10,
    '&>:last-child': {
      width: '100%',
      height: '2rem',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',

      [theme.devices.tablet]: {
        display: 'none',
      },
    },
  },

  tabIcon: {
    height: 26,
    width: 'auto',
  },

  tabContent: {
    width: '806px',
    minHeight: '510px',
    margin: 'auto 0px auto 30px',
    backgroundColor: theme.backgroundLight,

    [theme.devices.tablet]: {
      margin: 0,
      width: '100%',
      maxWidth: 'unset',
      minHeight: 'fit-content',
      marginTop: 20,
    },
  },
  selectionCardContent: {
    padding: '0 0 0 30px',
    gap: 10,

    [theme.devices.mobile]: {
      padding: 20,
    },
  },
  classNameFooter: {
    padding: '0 30px 20px 30px',
  },
  footer: {
    display: 'flex',
    columnGap: 25,
    alignItems: 'center',
    '& >:first-child': {
      display: 'flex',
      '& button': {
        marginRight: 20,
      },
    },
    [theme.devices.mobile]: {
      flexWrap: 'wrap',
    },
  },
  selectionCardContainer: {
    height: '100%',
    minHeight: 'inherit',
    '& > :first-child': {
      display: 'flex',
      margin: 'auto 0',
      justifyContent: 'space-between',
      '& > :first-child': {
        maxWidth: '31rem',
      },
      '& > :last-child': {
        margin: 'auto',
      },
    },
  },
  iconContainer: {
    backgroundColor: 'unset',
    margin: '30px 0 30px 30px',
    minHeight: 'unset',
    justifyContent: 'flex-start',
  },
  subscriptionTypeTitle: {
    color: theme.black,
    lineHeight: '40px',
    letterSpacing: '0.32px',
    marginBottom: 20,
    fontSize: theme.fontSizes.smedium,
    fontWeight: theme.fontWeights.medium,
  },
  title: {
    color: theme.black,
    marginBottom: 20,
    marginTop: 20,
  },
  text: {
    color: theme.black,
    textAlign: 'center',
    maxWidth: 750,
    margin: '0 auto',
    marginBottom: 40,
    fontSize: theme.fontSizes.default,

    [theme.devices.tablet]: {
      marginBottom: 20,
    },
  },
  learnMore: {
    cursor: 'pointer',
    color: theme.primary,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: 'auto',
    '& >a': {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
    },
  },
  boxWrapper: {
    paddingBottom: 20,
    display: 'flex',
    gap: 20,
    justifyContent: 'flex-start',
    minWidth: '400px',
    maxWidth: '1280px',
    maxHeight: '800px',
    '& > :first-child': {
      display: 'flex',
      alignItems: 'center',

      [theme.devices.tablet]: {
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '100%',
        minWidth: 'unset',
      },
    },
    [theme.devices.tablet]: {
      minWidth: 'unset',
      marginTop: 20,
    },
  },
  subscriptionTypeDescription: {
    fontSize: theme.fontSizes.smaller,
    fontWeight: theme.fontWeights.regular,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.67,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: theme.black,
    hyphens: 'auto',
    marginTop: '5px',

    [theme.devices.tablet]: {
      display: 'none',
    },
  },
  m10: {
    margin: '10px',
  },
  trialStatus: {
    [theme.devices.tablet]: {
      display: 'block',
      marginLeft: 10,
    },
  },
  subscriptionTypeBulletPoint: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    lineHeight: 2,
    [theme.devices.mobile]: {
      order: 1,
      flexBasis: '100%',
    },
  },
  subscriptionTypeBulletPointText: {
    margin: '0 0 0 1rem',
    letterSpacing: 'normal',
  },
}))

const SubscriptionTypeSelectionV2 = (props) => {
  const {
    onChange,
    useBulletPointIcons = true,
  } = props

  const { subscriptionTypeTypes } = useSelector(state => state.onboarding.mainV2)
  const { subscriptions } = useSelector(state => state.subscription.details)

  const classes = useStyles({ isMeinbuero })
  const isTablet = isTabletScreen()
  useElevateHubSpotChat()

  const [subscriptionTypesState, setSubscriptionTypesState] = useState([])

  useEffect(() => {
    if (subscriptionTypeTypes) {
      onTypeButtonClicked(subscriptionTypeTypes)
    }
  }, [subscriptionTypeTypes])

  const onTypeButtonClicked = (type) => {
    let newSubscriptionTypes
    if (subscriptionTypesState.includes(type)) {
      newSubscriptionTypes = subscriptionTypesState.filter(st => st !== type)
      if (ENV.product === 'orgamax') {
        GtmService.pushEvent({
          event: GtmEventTypes.GaEventHub,
          eventCategory: 'Multi-Testauswahl',
          eventAction: 'Entfernt',
          eventLabel: `Produktauswahl ${type}`,
        })
      }
    } else {
      newSubscriptionTypes = [...subscriptionTypesState, type]
      if (ENV.product === 'orgamax') {
        GtmService.pushEvent({
          event: GtmEventTypes.GaEventHub,
          eventCategory: 'Multi-Testauswahl',
          eventAction: 'Hinzugefügt',
          eventLabel: `Produktauswahl ${type}`,
        })
      }
    }
    setSubscriptionTypesState(newSubscriptionTypes)
    onChange && onChange(newSubscriptionTypes)
  }

  const onLearnMoreButtonClicked = (type) => {
    if (ENV.product === 'orgamax') {
      GtmService.pushEvent({
        event: GtmEventTypes.GaEventHub,
        eventCategory: 'Multi-Testauswahl',
        eventAction: 'Mehr erfahren',
        eventLabel: `Produktauswahl ${type}`,
      })
    }
  }

  const tabOverview = (subscriptionType) => {
    const subscriptionText = lang.subscriptionModal.subscriptionType.types[subscriptionType].trialSelectTabSummary
    const sTypeIcon = subscriptionTypeIcon[subscriptionType]
    const ownsType = subscriptions.some(sb => sb.typeOfSubscription === subscriptionType && !sb.type.includes('trial'))
    const triesType = subscriptions.some(sb => sb.typeOfSubscription === subscriptionType && sb.type.includes('trial'))
    const active = subscriptionTypesState.includes(subscriptionType) || ownsType || triesType
    const buttonLabel = active || triesType
      ? lang.subscriptionModal.subscriptionType.button.label.active
      : lang.subscriptionModal.subscriptionType.button.label.inactive

    const activeLabel = ownsType
      ? lang.subscriptionModal.owned
      : lang.subscriptionModal.trialVersionAdded

    return (
      <div className={classes.tabOverview}>
        <SVGIcon className={classes.tabIcon} svg={sTypeIcon} />
        <div className={classes.subscriptionTypeDescription}>
          {subscriptionText}
        </div>
        <div>
          {!ownsType && !triesType ? <a onClick={() => onTypeButtonClicked(subscriptionType)}>{buttonLabel}</a> : null}
          {active && (
            <div className={classes.subscriptionTypeBulletPoint}>
              <SVGIcon svg={CheckIcon} height={'12px'} width={'14px'} fill={theme.colorPrimaryButtonBackground} />
              <span
                className={clsx(classes.subscriptionTypeDescription, classes.m10)}
                dangerouslySetInnerHTML={{ __html: activeLabel }}
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  const tabContent = (subscriptionType) => {
    const productInfoLink = config.productInfoLinks[`${subscriptionType}InfoUrl`]
    const ownsType = subscriptions.some(sb => sb.typeOfSubscription === subscriptionType && !sb.type.includes('trial'))
    const triesType = subscriptions.some(sb => sb.typeOfSubscription === subscriptionType && sb.type.includes('trial'))
    const active = subscriptionTypesState.includes(subscriptionType) || ownsType || triesType

    const buttonLabel = active
      ? lang.subscriptionModal.subscriptionType.button.label.active
      : lang.subscriptionModal.subscriptionType.button.label.inactive

    const activeLabel = ownsType
      ? lang.subscriptionModal.owned
      : lang.subscriptionModal.trialVersionAdded

    const footerChildren = (
      <div className={classes.footer}>
        {!ownsType && !triesType
          ? <ButtonIconSquare
            variant="outline"
            actionId={subscriptionType}
            label={buttonLabel}
            onClick={() => onTypeButtonClicked(subscriptionType)}
          />
          : null}
        {active && (
          <div className={classes.subscriptionTypeBulletPoint}>
            <SVGIcon svg={CheckIcon} height={'12px'} width={'14px'} fill={theme.colorPrimaryButtonBackground} />
            <span
              className={clsx(classes.subscriptionTypeDescription, classes.m10, classes.trialStatus)}
              dangerouslySetInnerHTML={{ __html: activeLabel }}
            />
          </div>
        )}
        <div className={classes.learnMore}>
          <a href={productInfoLink} onClick={() => onLearnMoreButtonClicked(subscriptionType)} target="_blank">
            {lang.subscriptionModal.learnMore}
            <SVGIcon svg={ArrowBackIcon} {...iconProps} />
          </a>
        </div>
      </div>
    )
    return (
      <Fragment>
        <SelectionCard
          cardIcon={subscriptionTypeContentIcon[subscriptionType]}
          iconHeight="53px"
          iconWidth="289px"
          className={classes.subscriptionTypeTitle}
          classNameContainer={classes.selectionCardContainer}
          classNameFooter={classes.classNameFooter}
          iconContainer={classes.iconContainer}
          onClick={() => {}}
          value={subscriptionType}
          active={subscriptionTypesState.includes(subscriptionType)}
          footerChildren={footerChildren}
          classNameContent={classes.selectionCardContent}
          useContentIcon={true}
        >
          {lang.subscriptionModal.subscriptionType.types[subscriptionType]?.trialSelectBulletPoints.map((bulletPoint, index) => (
            bulletPoint && (
              <div className={classes.subscriptionTypeBulletPoint} key={index}>
                {useBulletPointIcons && <SVGIcon svg={CheckIcon} height={'12px'} width={'14px'} fill={theme.colorPrimaryButtonBackground} />}
                <span className={classes.subscriptionTypeBulletPointText} dangerouslySetInnerHTML={{ __html: bulletPoint }} />
              </div>)
          ))}
        </SelectionCard>
      </Fragment>
    )
  }

  return (
    <>
      <Title position={'center'} size={'medium'} className={classes.title} marginBottom={'40px'}>
        {lang.subscriptionModal.title}
      </Title>
      <div className={classes.text}>
        {lang.subscriptionModal.text}
      </div>

      <div className={classes.boxWrapper}>
        <TabInput
          key='toggleSupplierCustomer'
          customClass={classes.tabInput}
          muiClasses={{
            tab: classes.tab,
            labelIcon: classes.labelIcon,
            selected: classes.selected,
            disabled: classes.disabled,
            indicator: classes.indicator,
            root: classes.root,
            flexContainer: classes.tabContainer,
          }}
          tabs={[
            { key: 'main', label: tabOverview('main'), content: tabContent('main'), contentClass: classes.tabContent, tooltipText: lang.subscriptionModal.tooltipText },
            { key: 'document', label: tabOverview('document'), content: tabContent('document'), contentClass: classes.tabContent, tooltipText: lang.subscriptionModal.tooltipText },
            // { key: 'staff', label: tabOverview('staff'), content: tabContent('staff'), contentClass: classes.tabContent, tooltipText: lang.subscriptionModal.tooltipText },
          ]}
          orientation={isTablet ? 'horizontal' : 'vertical'}
          value={subscriptionTypeTypes ? TAB_INDICES[subscriptionTypeTypes] : 0}
        />
      </div>
    </>
  )
}

SubscriptionTypeSelectionV2.propTypes = {
  onChange: PropTypes.func.isRequired,
  useBulletPointIcons: PropTypes.bool,
}

export default SubscriptionTypeSelectionV2
